<template>
  <div class="div">
    <div class="div1">
      <div class="div_1">
        <div class="tip"></div>
        <h2 class="h">字体文件上传</h2>
      </div>
      <div class="history">
        <el-button @click.native="goFontrecord" size="small" slot="trigger" type="primary">查看历史</el-button>
      </div>
      <div class="div_2" style="user-select: none;">
        <el-select placeholder="请选择厂商" style="margin-bottom:20px;" v-model="formData.companyId">
          <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in companyList"></el-option>
        </el-select>
        <el-upload
          :accept="'ttf/*'"
          :auto-upload="false"
          :file-list="fileList"
          :multiple="true"
          :on-change="removeLastFile"
          :on-remove="handleRemove"
          action
          ref="upload"
        >
          <el-button size="small" slot="trigger">选择文件</el-button>
          <el-button
            @click="upload_file"
            size="small"
            style="margin-left: 10px;"
            type="success"
          >开始转换</el-button>
        </el-upload>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="上传成功" width="40%">
      <span>您可以选择到右上角菜单中的历史查询中查看转换结果</span>
      <div class="resultBox">
        <div class="successList">
          <div class="title" style="color:green">成功列表</div>
          <div class="List">
            <div :key="index" v-for="(item,index) in result.success">{{item}}</div>
          </div>
        </div>
        <div class="failList">
          <div class="title" style="color:red">失败列表(重复上传)</div>
          <div class="List">
            <div :key="index" v-for="(item,index) in result.fail">{{item}}</div>
          </div>
        </div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button @click="goFontrecord" type="primary">查看结果</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { uploadoss } from '@/utils/uploadoss'
import store from '../../store/index'
import { LoginCheck } from '../../assets/untils/login'

export default {
  data() {
    return {
      fileList: [],
      dialogVisible: false,
      filesUpload: [],
      tableData: [],
      formData: {
        companyId: '',
        fontNameList: [],
        urlList: []
      },
      result: {
        success: [],
        fail: []
      },
      companyList: [],
      myHeaders: {
        Authorization: store.state.token
      }
    }
  },

  watch: {},
  created() {},
  mounted() {
    let viewport = document.querySelector('meta[name=viewport]')
    viewport.setAttribute('content', '')
    this.getCompanyByUser()
  },
  updated() {},
  methods: {
    //历史查询
    goFontrecord() {
      this.$router.push({
        path: '/layout/record'
      })
    },
    //上传文件
    upload_file() {
      let obj = this.fileList[0]
      const promises = []
      this.formData.fontNameList = []
      this.formData.urlList = []

      if (undefined === obj) {
        return
      }
      if (this.formData.companyId === '') {
        this.$message({
          message: '请选择厂商',
          type: 'error',
          duration: 1000
        })
        return false
      }
      this.openFullScreen()
      this.fileList.forEach(e => {
        promises.push(uploadoss(e))
      })
      Promise.all(promises).then(res => {
        this.closeFullScreen(this.openFullScreen())
        res.forEach(e => {
          this.formData.fontNameList.push(e.name.split('-')[1].split('.')[0])
          this.formData.urlList.push(decodeURIComponent(e.url))
        })
        this.fontTransform()
      })
    },
    handlebeforeup(file) {
      this.openFullScreen()
      window.stop()
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      console.log(this.fileList)
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleerror(err) {
      this.closeFullScreen(this.openFullScreen())
      this.$message({
        message: '上传服务接口失败',
        type: 'error',
        duration: 1000
      })
    },

    //新增文件时删除前一个
    removeLastFile(file, fileList) {
      // fileList = []
      // fileList[0] = file
      let newArray = this.removeDuplicatedItem(fileList)
      this.fileList = newArray
      console.log(this.fileList)
    },
    // 文件去重
    removeDuplicatedItem(arr) {
      let tmp = {},
        ret = []
      for (var i = 0, j = arr.length; i < j; i++) {
        if (!tmp[arr[i].name]) {
          tmp[arr[i].name] = 1
          ret.push(arr[i])
        } else {
          this.$message({
            message: '同名文件不允许重复添加',
            type: 'error',
            duration: 1000
          })
        }
      }
      return ret
    },
    //接口方法
    fontTransform() {
      // this.formData.url = decodeURIComponent(this.formData.url)
      this.$api.search.fontTransform(this.formData).then(res => {
        if (res.data.code == 0) {
          this.result.success = res.data.data.successList
          this.result.fail = res.data.data.failedList
          this.dialogVisible = true
        }
      })
    },
    getCompanyByUser() {
      this.$api.search.getCompanyByUser().then(res => {
        if (res.data.code == 0) {
          this.companyList = res.data.data
        }
      })
    },

    //移动端判断
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },

    //加载蒙版
    openFullScreen() {
      const loading = this.$loading({
        lock: true,
        text: '等待上传',
        spinner: 'el-icon-loading',
        customClass: 'Loadingc',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      return loading
    },
    closeFullScreen(loading) {
      loading.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.div {
  width: 80%;
  height: calc(100vh - 63px);
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  .div1 {
    width: 100%;
    height: 60rem;
    background-color: #fff;
    padding: 1rem;
    border-bottom: 0.1rem solid #b7b7b7;
    box-sizing: border-box;
    .history {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .div_1 {
      position: relative;
      height: 2rem;
    }
    .div_2 {
      margin-top: 16rem;
    }
  }
}
@media screen and (max-width: 1000px) {
  .div {
    width: 90%;
    margin: 0 auto;
  }
}

* /deep/ .el-table thead {
  color: #000;
  font-weight: 800;
}

* /deep/ .el-loading-text {
  color: orange !important;
}

* /deep/ .el-upload-list {
  max-height: 170px;
  overflow: auto;
}
.resultBox {
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .successList,
  .failList {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    .title {
      font-weight: bold;
    }
    .List {
      width: 100%;
      height: 140px;
      overflow: auto;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
    }
  }
}

.tip {
  background-color: blueviolet;
  width: 0.4rem;
  height: 2rem;
  display: inline-block;
  border-radius: 0.5rem;
  position: absolute;
  left: 1rem;
}

.h {
  font-size: 2rem;
  line-height: 2rem;
  position: absolute;
  left: 2rem;
}

.canvas {
  width: 80%;
  min-height: 50rem;
  max-height: 80rem;
  margin: 0 auto;
}

.img {
  object-fit: fill;
  display: block;
  max-height: 80rem;
  max-width: 80%;
  margin: 0 auto;
}

.sp1 {
  font-size: 1.4rem;
}

.sp2 {
  font-size: 2.8rem;
}
</style>
